import React, {useRef} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Box, Card, CardContent, Tooltip, IconButton} from '@mui/material';
import Info from '@mui/icons-material/Info';
import {COLORS, EXPORTING} from '@/utils/constants';

interface IMaintenanceInterventionsProps {
    scheduledMaintenanceSubmissions: any[],
    maintenanceCarriedOutSubmissions: any[],
}

const MaintenanceInterventions = ({
                                      scheduledMaintenanceSubmissions,
                                      maintenanceCarriedOutSubmissions
                                  }: IMaintenanceInterventionsProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

    return (
        <Box>
            <Box>
                <Box className='section-title'>
                    <Box>
                        1. INTERVENTI DI MANUTENZIONE
                    </Box>
                    <Tooltip
                        title={<>
                            Il visual mostra il confronto fra:
                            <li> il numero di possibili interventi di manutenzione mappati e il corrispondente valore
                                atteso
                                per il progetto;</li>
                            <li>il numero di abitazioni in cui è stato effettivamente realizzato almeno un intervento di
                                manutenzione e il corrispondente valore atteso per il progetto;
                            </li>
                            I valori effetti sono ottenuti a partire da “Scheda di rilevazione degli interventi di
                            manutenzione previsti” e “Scheda di rilevazione degli interventi di manutenzione
                            realizzati”. I valori attesi fanno riferimento al documento riepilogativo KPI di progetto
                            (100 sopralluoghi effettuati per possibili interventi di manutenzione e 80 abitazioni in cui
                            è stato realizzato almeno un intervento di manutenzione,).
                        </>}
                    >
                        <IconButton>
                            <Info fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Card>
                    <CardContent>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={{
                                chart: {
                                    height: 400,
                                    type: 'column',
                                    style: {
                                        fontFamily: 'Rubik, sans-serif'
                                    },
                                    backgroundColor: '#fafafa'
                                },
                                title: {
                                    text: '',
                                },
                                xAxis: {
                                    categories: ['Sopralluoghi', 'Abitazioni con almeno un intervento']
                                },
                                yAxis: {
                                    title: {
                                        text: '',
                                    },
                                },
                                series: [
                                    {
                                        color: COLORS.blue,
                                        name: 'Valore Effetivo',
                                        data: [scheduledMaintenanceSubmissions.length, maintenanceCarriedOutSubmissions.length]
                                    },
                                    {
                                        color: COLORS.red,
                                        name: 'Valore Atteso',
                                        data: [100, 80]
                                    },
                                ],
                                exporting: EXPORTING,
                            }}
                            ref={chartComponentRef}
                        />
                    </CardContent>
                </Card>
            </Box>
        </Box>
    )
}

export default MaintenanceInterventions;